import { Box, styled } from '@mui/material';
import React from 'react';
import { SidebarList } from '../models/SidebarList';
import { SingleLevel } from './SidebarComponents/SingleLevel';
import { MultiLevel } from './SidebarComponents/MultiLevel';

const StyledBasketSidebar = styled(Box)(() => ({
    width: '300px',
    marginLeft: '97px',
    marginTop: '40px'
}));

export interface SidebarListProps {
    item: SidebarList;
    path?: string;
}

interface SidebarProps {
    menu: SidebarList[];
    active: string;
    setActive: Function;
    path: string;
}

export function Sidebar({ active, menu, setActive, path }: SidebarProps): JSX.Element {
    const MenuItem = ({ item }: SidebarListProps): JSX.Element => {
        return item.items && item.items?.length > 0 ? (
            <MultiLevel item={item} active={active} setActive={setActive} />
        ) : (
            <SingleLevel item={item} path={path} />
        );
    };

    return (
        <StyledBasketSidebar>
            {menu.map((item, key) => (
                <MenuItem key={key} item={item} />
            ))}
        </StyledBasketSidebar>
    );
}
